import { gql } from "@apollo/client";
import { errorFragment } from "trading/api/fragment";

export const UPLOAD_CSV_FILE = gql`
  mutation UploadCsv($input: UploadCsvInput!) {
    uploadCsv(input: $input) {
      id
      rows
      fields
      totalColumns
      totalRows
      errors {
        ...errorFragment
      }
    }
  }
  ${errorFragment}
`;

export const IMPORT_CSV_FILE = gql`
  mutation ImportCsv($input: ImportCsvInput!) {
    importCsv(input: $input) {
      taskId
      errors {
        ...errorFragment
      }
    }
  }
  ${errorFragment}
`;
